export default {
    searchSuggestion: 'ค้นหาโดยรหัสพนักงานหรือชื่อ',
    search: 'ค้นหา',
    startDate: 'วันเริ่มต้น',
    endDate: 'วันสิ้นสุด',
    employeeNo: 'รหัสพนักงาน',
    employeeName: 'ชื่อ - นามสกุล',
    date: 'วันที่',
    time: 'เวลา',
    exportExcel: 'ดาวน์โหลด Excel',
    exportPdf: 'ดาวน์โหลด PDF',
    hasNoPermission: 'ฟังก์ชั่นนี้ไม่ได้เปิดใช้งานกับกะการทำงานของคุณ'
}
